import { Brain, Dumbbell, Leaf, Heart } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";

const ICONS = { Brain, Dumbbell, Leaf, Heart };

const BLOCKS = [
  { key: "Brain", title: "MIND", items: ["Mental Strength", "Focus", "Discipline", "Motivation", "Positive Habits"] },
  { key: "Dumbbell", title: "BODY", items: ["Strength", "Fitness", "Mobility", "Conditioning", "Physical Performance"] },
  { key: "Leaf", title: "GUT & NUTRITION", items: ["Eating Habits", "Nutrition Awareness", "Digestive Wellness", "Sustainable Food Choices"] },
  { key: "Heart", title: "LIFESTYLE", items: ["Daily Routine", "Sleep", "Habits", "Stress Management", "Long-Term Wellness"] },
];

export const Philosophy = () => {
  return (
    <section className="relative bg-[#020617] py-24 sm:py-32 px-5 sm:px-8" data-testid="philosophy-section">
      <div className="max-w-7xl mx-auto">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">The Philosophy</span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4">
            MIND + BODY + GUT + LIFESTYLE = COMPLETE HEALTH
          </h2>
          <p className="text-slate-400 mt-4 max-w-2xl text-sm sm:text-base">
            True wellness cannot be achieved by focusing on only one area. When everything works together, your transformation becomes powerful.
          </p>
        </ScrollReveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {BLOCKS.map((b, i) => {
            const Icon = ICONS[b.key];
            return (
              <ScrollReveal key={b.title} delay={i * 0.08} className="relative rounded-2xl p-7 glass-card overflow-hidden group" data-testid={`philosophy-block-${b.title.split(" ")[0].toLowerCase()}`}>
                <span className="absolute -right-3 -top-3 font-display font-extrabold text-6xl text-white/[0.03]">
                  0{i + 1}
                </span>
                <Icon size={26} className="text-cyan-400 mb-5 relative z-10" />
                <h3 className="font-display font-bold text-base text-white tracking-wide relative z-10">{b.title}</h3>
                <ul className="mt-4 space-y-1.5 relative z-10">
                  {b.items.map((it) => (
                    <li key={it} className="text-xs sm:text-sm text-slate-400">
                      · {it}
                    </li>
                  ))}
                </ul>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
